<template>
  <div>
    <h2>Vill du avbryta avtalsförfrågan?</h2>
    <p>Lorem Ipsum</p>
    <button-group class="c-m-button-group--margin-bottom no-print">
      <atom-button
        label="Tillbaka"
        class="c-a-button--theme-white"
        @buttonClicked="$emit('close')"
      />
      <atom-button
        :label="'Ja, jag vill avbryta avtalsförfrågan'"
        class="c-a-button--theme-primary"
        @buttonClicked="$emit('confirmedAbort')"
      ></atom-button>
    </button-group>
  </div>
</template>

<script>
import AtomButton from "./AtomButton.vue";
import ButtonGroup from "../molecules/MoleculeButtonGroup";

export default {
  components: {
    AtomButton,
    ButtonGroup
  },
  props: {
    computed: {}
  }
};
</script>


// WEBPACK FOOTER //
// src/views/components/atoms/AtomAbortContractConfirmation.vue